module.exports = __webpack_public_path__ + "img/market.66992d9d.svg";